import { Controller } from 'react-hook-form';
import { InputText, Select, SidePanelRow, Checkbox } from '@ui/src';
import { ChartType } from '../../../hoc/charts/types';

import { ChartPanelAccountProps } from './types';

const ChartPanelCategory = ({
  control,
  typeOptions,
  errors,
  categoryId,
}: ChartPanelAccountProps): React.JSX.Element => (
  <>
    <SidePanelRow caption="Category name">
      <Controller
        control={control}
        defaultValue=""
        name="name"
        render={({ field: { onChange, value } }) => (
          <InputText
            placeholder="Enter name..."
            name="name"
            value={value}
            onChange={onChange}
            error={errors.name?.message}
          />
        )}
      />
    </SidePanelRow>
    <SidePanelRow caption="Account type">
      <Controller
        control={control}
        defaultValue={ChartType.DEBIT}
        name="type"
        render={({ field: { onChange, value } }) => (
          <Select
            name="type"
            onChange={onChange}
            value={value}
            list={typeOptions}
            error={errors.type?.message}
            disabled={Boolean(categoryId)}
          />
        )}
      />
    </SidePanelRow>
    {categoryId && (
      <SidePanelRow>
        <Controller
          control={control}
          defaultValue={false}
          name="active"
          render={({ field: { onChange, value } }) => (
            <Checkbox
              type="checkbox"
              name="active"
              checked={value}
              title="Active"
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
      </SidePanelRow>
    )}
  </>
);

export default ChartPanelCategory;
